import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV, Environment } from '@core/core.tokens';
import { Method } from 'axios';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { DeliveryPoint } from './models/delivery-point.model';
import { Employee } from './models/employee.model';
import { PurposeNodeGate } from './models/purpose.model';

export interface RequestOptions {
  body?: any;
  headers?: HttpHeaders | undefined;
  params?: HttpParams | undefined;
};


@Injectable()
export class AliaBackendService {

  constructor(
    private http: HttpClient,
    @Inject(ENV) private env: Environment
  ) { }

  request<T>(method: Method, path: string, options?: RequestOptions) {
    const { customization: { url, system, apiKey } } = this.env;
    const defaultHeaders = {
      'x-system': system,
      'x-apikey': apiKey
    };
    const opts = {
      ...options,
      headers: {
        ...(options ? options.headers : {}),
        ...defaultHeaders
      }
    };
    return this.http.request<T>(method, `${url}${path}`, opts).pipe(first());
  }

  getNotConfirmedEmployees() {
    return this.request<Employee[]>('GET', '/api/user/not-confirmed');
  }

  getConfirmedEmployees() {
    return this.request<Employee[]>('GET', '/api/user/confirmed');
  }

  getDeliveryPoint(): Observable<DeliveryPoint[]> {
    return this.request<DeliveryPoint[]>('GET', '/api/node-gate/delivery-point').pipe(map(r => (r as any).data));
  }
  getPurpose() {
    return this.request<PurposeNodeGate[]>('GET', '/api/node-gate/purpose').pipe(map(r => (r as any).data));
  }

}
